import React from "react";
import "./PeoplePreviewRow.scss";

const PeoplePreviewRow = ({ users, loading, error, onOpenProfile, onShowMore, hideHeading = false }) => {
  const hasUsers = Array.isArray(users) && users.length > 0;

  return (
    <div className="people-preview">
      {!hideHeading && (
        <div className="people-preview__head">
          <h3 className="people-preview__title">Люди</h3>
        </div>
      )}

      {loading && !hasUsers && (
        <div className="people-preview__row">
          {Array.from({ length: 8 }).map((_, i) => (
            <div className="people-preview__item shimmer" key={`ppl-skel-${i}`}>
              <div className="people-preview__avatar-skel" />
              <div className="people-preview__name-skel" />
            </div>
          ))}
        </div>
      )}

      {error && <div className="error">{error}</div>}

      {hasUsers && (
        <div className="people-preview__row">
          {users.map((user) => (
            <button
              type="button"
              key={user.id}
              className="people-preview__item"
              onClick={() => onOpenProfile(user.id)}
            >
              <img src={user.avatar} alt={user.username} className="people-preview__avatar" />
              <span className="people-preview__name">{user.username}</span>
            </button>
          ))}

          {onShowMore && (
            <button type="button" className="people-preview__more-circle" onClick={onShowMore}>
              <span aria-hidden="true">›</span>
            </button>
          )}
        </div>
      )}

      {!loading && !hasUsers && !error && (
        <p className="people-preview__empty">Нікого не знайдено</p>
      )}
    </div>
  );
};

export default PeoplePreviewRow;
